/**
 * Stage Finance assumptions store — persisted per deal, keyed by scenario id.
 */

import { DEFAULT_ASSUMPTIONS, hydrateAssumptions } from '../stageFinance/defaults';

export function hydrateStageFinanceAssumptionsStore(raw) {
  if (!raw || typeof raw !== 'object') {
    return { byScenarioId: {} };
  }
  const byScenarioId = {};
  const source = raw.byScenarioId && typeof raw.byScenarioId === 'object'
    ? raw.byScenarioId
    : raw;
  for (const [id, value] of Object.entries(source || {})) {
    if (!id) continue;
    byScenarioId[id] = hydrateAssumptions({ ...DEFAULT_ASSUMPTIONS, ...(value || {}) });
  }
  return { byScenarioId };
}

export function getStageFinanceAssumptionsForScenario(store, scenarioId) {
  const hydrated = hydrateStageFinanceAssumptionsStore(store);
  if (!scenarioId) return null;
  return hydrated.byScenarioId[scenarioId] || null;
}

export function upsertStageFinanceAssumptionsForScenario(store, scenarioId, assumptions) {
  const hydrated = hydrateStageFinanceAssumptionsStore(store);
  if (!scenarioId) return hydrated;
  return {
    byScenarioId: {
      ...hydrated.byScenarioId,
      [scenarioId]: hydrateAssumptions({ ...DEFAULT_ASSUMPTIONS, ...(assumptions || {}) }),
    },
  };
}
